<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedi"></a><a id="page_vii"><em>For Nate, aka Hot Cop</em></a></p><a id="page_vii">
<p class="ded1">Thank you for being so patient with<br/>my nearly constant state of “deadline dementia,”<br/>which is occasionally broken by the famed <br/>“pre-release jitters,” closely followed by <br/>a (very short) period of “book release euphoria.”</p>
<p class="deda">You make my soul grin.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5f14e354